import * as React from 'react';
import { SVGProps } from 'react';

const IconLithologyFilledSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2Zm5 2h2v2H7V3ZM5 7H3v2h2V7Zm6 0h2v2h-2V7Zm-4 4h2v2H7v-2Z"
    />
  </svg>
);
export default IconLithologyFilledSizeS;
